var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBecomeadealer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 630,
    height: 1445,
    viewBox: "0 0 630 1445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "becomeadealer",
    transform: "translate(-1004 -28172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M26,0H604a26,26,0,0,1,26,26V1445a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V26A26,26,0,0,1,26,0Z",
    transform: "translate(1004 28172)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28317)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-2",
    "data-name": "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28597)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-3",
    "data-name": "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(1083 29017)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-4",
    "data-name": "Title",
    width: 161,
    height: 13,
    rx: 6.5,
    transform: "translate(1324 29179)",
    fill: "#77777a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-5",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28353)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-6",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28635)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-7",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1083 29055)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-8",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1324 29217)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-9",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28377)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-10",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28659)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-11",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1083 29079)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-12",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1324 29241)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-13",
    "data-name": "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28683)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-14",
    "data-name": "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(1083 29103)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-15",
    "data-name": "Title",
    width: 139,
    height: 13,
    rx: 6.5,
    transform: "translate(1324 29265)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-16",
    "data-name": "Title",
    width: 204,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28402)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-17",
    "data-name": "Title",
    width: 126,
    height: 13,
    rx: 6.5,
    transform: "translate(1101 28426)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7017",
    "data-name": "Group 7017",
    transform: "translate(-3 1453)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_3",
    "data-name": 3,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1565 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_2",
    "data-name": 2,
    width: 24,
    height: 11,
    rx: 5.5,
    transform: "translate(1530 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_1",
    "data-name": 1,
    width: 23,
    height: 11,
    rx: 5.5,
    transform: "translate(1495 26750)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    width: 56,
    height: 18,
    rx: 9,
    transform: "translate(1055 26746)",
    fill: "#858585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1599",
    "data-name": "Rectangle 1599",
    width: 141,
    height: 174,
    rx: 35,
    transform: "translate(1363 28292)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1603",
    "data-name": "Rectangle 1603",
    width: 141,
    height: 174,
    rx: 35,
    transform: "translate(1132 29330)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-18",
    "data-name": "Title",
    width: 61,
    height: 10,
    rx: 5,
    transform: "translate(1057 28497)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-19",
    "data-name": "Title",
    width: 38,
    height: 10,
    rx: 5,
    transform: "translate(1057 28260)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-20",
    "data-name": "Title",
    width: 51,
    height: 10,
    rx: 5,
    transform: "translate(1107 28260)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-21",
    "data-name": "Title",
    width: 12,
    height: 41,
    rx: 6,
    transform: "translate(1580 28466)",
    fill: "#5e5e5e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BG-2",
    "data-name": "BG",
    width: 171,
    height: 171,
    rx: 15,
    transform: "translate(1046 28765)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 102.75,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1080.125 28894.334)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 137,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1063 28877)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-22",
    "data-name": "Title",
    width: 85,
    height: 9,
    rx: 4.5,
    transform: "translate(1089 28854)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "BG-3",
    "data-name": "BG",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(1110 28795)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BG-4",
    "data-name": "BG",
    width: 172,
    height: 171,
    rx: 15,
    transform: "translate(1233 28765)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-3",
    "data-name": "Path",
    width: 102.75,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1268.125 28894.334)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-4",
    "data-name": "Path",
    width: 137,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1251 28877)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-23",
    "data-name": "Title",
    width: 86,
    height: 9,
    rx: 4.5,
    transform: "translate(1276 28854)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "BG-5",
    "data-name": "BG",
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    transform: "translate(1298 28795)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "BG-6",
    "data-name": "BG",
    width: 171,
    height: 171,
    rx: 15,
    transform: "translate(1421 28765)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-5",
    "data-name": "Path",
    width: 102.75,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1455.125 28894.334)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path-6",
    "data-name": "Path",
    width: 137,
    height: 8.667,
    rx: 4.333,
    transform: "translate(1438 28877)",
    fill: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Title-24",
    "data-name": "Title",
    width: 85,
    height: 9,
    rx: 4.5,
    transform: "translate(1464 28854)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "BG-7",
    "data-name": "BG",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(1485 28795)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1600",
    "data-name": "Rectangle 1600",
    width: 29,
    height: 6,
    rx: 3,
    transform: "translate(1563 28738)",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1601",
    "data-name": "Rectangle 1601",
    width: 29,
    height: 6,
    rx: 3,
    transform: "translate(1523 28738)",
    fill: "#858585"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBecomeadealer);
export default __webpack_public_path__ + "static/media/becomeadealer.ec73ebab2ae3c1c8092f055b6c2e57dd.svg";
export { ForwardRef as ReactComponent };